import React from 'react';
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import { Link } from 'react-router-dom';
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';

// Fix for default marker icon
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon-2x.png',
  iconUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon.png',
  shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-shadow.png',
});

const PropertyMap = ({ properties, center = [53.37, -3.01], zoom = 10, height = '500px' }) => {
  return (
    <div style={{ height, width: '100%', borderRadius: '16px', overflow: 'hidden', border: '2px solid #e8e8e8' }}>
      <MapContainer 
        center={center} 
        zoom={zoom} 
        style={{ height: '100%', width: '100%' }}
        scrollWheelZoom={false}
      >
        <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        {properties.map((property) => (
          property.latitude && property.longitude && (
            <Marker 
              key={property.id} 
              position={[property.latitude, property.longitude]}
            >
              <Popup>
                <div style={{ minWidth: '200px' }}>
                  <img 
                    src={property.images[0]} 
                    alt={property.name}
                    style={{ width: '100%', height: '120px', objectFit: 'cover', borderRadius: '8px', marginBottom: '8px' }}
                  />
                  <h3 style={{ fontSize: '16px', fontWeight: 'bold', marginBottom: '4px', color: '#1a1a2e' }}>
                    {property.name}
                  </h3>
                  <p style={{ fontSize: '14px', color: '#636e72', marginBottom: '4px' }}>
                    {property.bedrooms} bed • {property.guests} guests
                  </p>
                  <p style={{ fontSize: '16px', fontWeight: 'bold', color: '#d4a574', marginBottom: '8px' }}>
                    £{property.nightly_rate}/night
                  </p>
                  <Link 
                    to={`/properties/${property.id}`}
                    style={{
                      display: 'block',
                      textAlign: 'center',
                      padding: '8px',
                      background: 'linear-gradient(135deg, #d4a574, #e8c9a1)',
                      color: 'white',
                      borderRadius: '8px',
                      textDecoration: 'none',
                      fontWeight: '600'
                    }}
                  >
                    View Property
                  </Link>
                </div>
              </Popup>
            </Marker>
          )
        ))}
      </MapContainer>
    </div>
  );
};

export default PropertyMap;